/******/ (() => { // webpackBootstrap
/******/ 	"use strict";

;// ./src/js/ObfLinks.js
class ObfLinks {
  init = () => {
    this.eventTypes = ['mouseover', 'focusin'];

    this.links = document.querySelectorAll('[data-href]');

    if (this.links.length > 0) {
      this.eventTypes.forEach((eventType) => {
        document.addEventListener(eventType, () =>
          this.mouseOverHandler(this.links)
        );
      });

      this.links.forEach((item) => {
        item.addEventListener('click', () => this.clickHandler(item));
      });
    }
  };

  mouseOverHandler = (links) => {
    links.forEach((item) => this.transformHref(item));
    this.eventTypes.forEach((eventType) => {
      document.removeEventListener(eventType, this.mouseOverHandler);
    });
  };

  transformHref = (element) => {
    if (element.dataset.href) {
      element.href = atob(element.dataset.href);
      delete element.dataset.href;
    }
  };

  clickHandler = (item) => {
    this.transformHref(item);
    item.removeEventListener('click', this.clickHandler);
  };
}

;// ./src/js/ProductDescriptionReadMore.js
class ProductDescriptionReadMore {
  constructor() {
    this.containerSelector = '.product-info__description';
    this.textSelector = '.product-info__description-text';
    this.toggleSelector = '.product-info__description-toggle';
  }

  init = () => {
    const container = document.querySelector(this.containerSelector);
    if (!container) return;

    const text = container.querySelector(this.textSelector);
    const toggle = container.querySelector(this.toggleSelector);
    if (!text || !toggle) return;

    const isTruncated = text.scrollHeight > text.clientHeight + 1;
    if (!isTruncated) return;

    text.classList.add('product-info__description-text--truncated');
    toggle.hidden = false;
    toggle.addEventListener('click', () =>
      this.toggleDescription(text, toggle)
    );
  };

  toggleDescription = (text, toggle) => {
    const expanded = text.classList.toggle(
      'product-info__description-text--expanded'
    );
    text.classList.toggle(
      'product-info__description-text--truncated',
      !expanded
    );
    toggle.setAttribute('aria-expanded', expanded);
    toggle.textContent = expanded
      ? toggle.dataset.labelLess
      : toggle.dataset.labelMore;
  };
}

;// ./src/js/RestockProduct.js
class RestockProduct {
  init = () => {
    const buyButtons = document.getElementById('buy-button-webqam');
    if (!buyButtons) return;

    const instockButton = buyButtons.querySelector('.buy-buttons__instock');
    if (!instockButton) return;

    const restockContainer = buyButtons.querySelector('.buy-buttons__restock');
    if (!restockContainer) return;

    const formId = buyButtons.getAttribute('form');
    const form = formId ? document.forms[formId] : null;
    if (!form) return;

    form.addEventListener('variant:change', (event) => {
      if (event.detail.variant?.available) {
        restockContainer.classList.add('buy-buttons__restock--hidden');
        instockButton.classList.remove('buy-buttons__instock--hidden');
      } else {
        restockContainer.classList.remove('buy-buttons__restock--hidden');
        instockButton.classList.add('buy-buttons__instock--hidden');
      }
    });
  };
}

;// ./src/js/DeliveryDelay.js
class DeliveryDelay {
  constructor() {
    this.textIconSelector = '.wq-delivery-infos__text-icon';
    this.firstDateSelector = '.wq-delivery-infos__text-bold-date--first';
    this.secondDateSelector = '.wq-delivery-infos__text-bold-date--second';
    this.holidays = [];
  }

  init = async () => {
    const textIcons = document.querySelectorAll(this.textIconSelector);

    if (!textIcons.length > 0) {
      return;
    }

    const today = new Date();
    const year = today.getFullYear();

    try {
      const response = await fetch(
        `https://calendrier.api.gouv.fr/jours-feries/metropole/${year}.json`
      );
      const data = await response.json();
      this.holidays = Object.keys(data).map((date) => new Date(date));
    } catch (error) {
      /* eslint-disable-next-line no-console */
      console.error('Erreur lors du chargement des jours fériés :', error);
    }

    textIcons.forEach((textIcon) => {
      const firstDate = textIcon.querySelector(this.firstDateSelector);
      const secondDate = textIcon.querySelector(this.secondDateSelector);
      const delayMin = firstDate.dataset.deliveryDelayMin;
      const delayMax = secondDate.dataset.deliveryDelayMax;

      if (!firstDate || !secondDate) {
        return;
      }

      const options = {
        month: 'short',
        day: 'numeric',
      };

      const estimatedDate = this.addWorkingDays(today, delayMin);
      firstDate.innerText = estimatedDate.toLocaleDateString('fr-FR', options);

      const estimatedDateMax = this.addWorkingDays(today, delayMax);
      secondDate.innerText = estimatedDateMax.toLocaleDateString(
        'fr-FR',
        options
      );

      textIcon.style.opacity = 1;
    });
  };

  isWorkingDay = (date) => {
    const day = date.getDay();
    const isWeekend = day === 0 || day === 6; // Sunday = 0, Saturday = 6
    const isHoliday = this.holidays.some(
      (holiday) => holiday.toDateString() === date.toDateString()
    );
    return !isWeekend && !isHoliday;
  };

  addWorkingDays = (startDate, daysToAdd) => {
    const date = new Date(startDate);
    let addedDays = 0;
    while (addedDays < daysToAdd) {
      date.setDate(date.getDate() + 1);
      if (this.isWorkingDay(date)) {
        addedDays++;
      }
    }
    return date;
  };
}

;// ./src/main.js


// JS goes here





window.addEventListener('load', () => {
  const classes = [
    new ObfLinks(),
    new RestockProduct(),
    new ProductDescriptionReadMore(),
    new DeliveryDelay(),
  ];
  classes.forEach((classe) => classe.init());
});

/******/ })()
;